import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBpost = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 32,
		height: 32,
		rx: 16,
		fill: "#E4032E"
	}), /* @__PURE__ */ _jsxs("g", {
		transform: "translate(7 7) scale(0.168363) translate(0.656 14.796)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M80.3,9.6c-9.3,20.3-31,41-48.4,46.3C14.4,61.2,7.8,49,17.2,28.7l-9.3,2.8C3.6,40.9,1.4,49.2,1.4,56v0.6\n			c0.1,15,10.6,22,28.9,16.4C57,65,90.1,33.3,104.2,2.4L80.3,9.6z",
			fill: "#fff"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M21.4,27.4c-4.8,10.4-1.4,16.6,7.5,13.9c8.9-2.7,20-13.3,24.7-23.6L21.4,27.4z",
			fill: "#fff"
		})]
	})]
});
export default SvgBpost;
